// =============================================
// Intellectural Property of Tony Capewell
// Independent Full Stack Developer at TLN SAAS HOLDINGS LIMITED for Your Cloud Works, Gallery View and MSP Dark Web
// Email: tjcapewell@gmail.com
// Phone: 07725 039920
// Created: 2026-04-29
// =============================================

import { Box, Dialog, DialogTitle, DialogContent, DialogActions, Typography } from '@mui/material';

interface Props {
  open: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  /**
   * An optional SECOND answer to the same question, shown beside Confirm.
   *
   * For decisions where the two outcomes need explaining side by side rather
   * than choosing between two buttons on a row before you have read what the
   * difference is — "archive" against "archive and delete" being the case
   * this was added for. Always rendered in the danger style, because a second
   * answer is only worth the room when it is the more final one.
   */
  secondaryLabel?: string;
  onSecondary?: () => void;
  // 'danger' = red button (destructive actions like delete), 'primary' = navy
  tone?: 'primary' | 'danger';
  onConfirm: () => void;
  onCancel: () => void;
}

export default function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  tone = 'primary',
  secondaryLabel,
  onSecondary,
  onConfirm,
  onCancel,
}: Props) {
  const confirmStyle = tone === 'danger'
    ? { bgcolor: '#753742', borderColor: '#753742', color: '#fff' }
    : { bgcolor: '#003554', borderColor: '#003554', color: '#fff' };
  return (
    <Dialog open={open} onClose={onCancel} PaperProps={{ sx: { borderRadius: '12px', maxWidth: secondaryLabel ? 480 : 400 } }}>
      <DialogTitle sx={{ fontSize: '15px', fontWeight: 700, color: '#003554', p: '16px 20px' }}>{title}</DialogTitle>
      <DialogContent sx={{ p: '0 20px 12px !important' }}>
        <Typography sx={{ fontSize: '13px', color: '#7a7060' }}>{message}</Typography>
      </DialogContent>
      <DialogActions sx={{ p: '14px 20px', gap: '10px', flexWrap: 'wrap' }}>
        <Box component="button" onClick={onCancel}
          sx={{ p: '8px 18px', borderRadius: '6px', fontSize: '13px', fontWeight: 600, cursor: 'pointer', border: '1.5px solid #e0dbd4', bgcolor: '#fff', color: '#4D4730', fontFamily: 'inherit' }}>
          {cancelLabel}
        </Box>
        {secondaryLabel && onSecondary && (
          <Box component="button" onClick={onSecondary}
            sx={{ p: '8px 18px', borderRadius: '6px', fontSize: '13px', fontWeight: 600, cursor: 'pointer', border: '1.5px solid #753742', bgcolor: '#fff', color: '#753742', fontFamily: 'inherit', '&:hover': { bgcolor: '#f5e8ea' } }}>
            {secondaryLabel}
          </Box>
        )}
        <Box component="button" onClick={onConfirm}
          sx={{ p: '8px 18px', borderRadius: '6px', fontSize: '13px', fontWeight: 600, cursor: 'pointer', border: '1.5px solid', fontFamily: 'inherit', ...confirmStyle }}>
          {confirmLabel}
        </Box>
      </DialogActions>
    </Dialog>
  );
}
